export default {"LABEL":"Background Rules 背景规则","DESC":"背景填充配色规则","COMPONENTS":{"__markdown":true}}